module.exports = __webpack_public_path__ + "static/img/4.5a104a4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/15/eng/4.png
// module id = +k1c
// module chunks = 0